import { ReactElement, useEffect, useState } from "react";
import { T } from "react-translator-component";
import { Avatar, Box, Typography } from "@mui/material";
import profile from "../../../assets/images/profile_img.png";
import { colors } from "../../../common/colors";
import { useAppDispatch } from "../../../redux/store";
import dayjs from "../../../util/dayjs";
import { convertUserImage } from "../../../util/utils";
import { setErrorObj } from "../../redux/errorReducer";
import apiServices from "../../services/apiServices";
import DisplayModal from "../DisplayModal";

interface Props {
  open: boolean;
  post: any;
  highlightWords: string[];
  onClose: () => void;
}

export default function ReportReasonModal({open, post, highlightWords, onClose}: Props): ReactElement {
  const dispatch = useAppDispatch();

  const [reports, setReports] = useState<any[]>([]);

  useEffect(() => {
    if (!open) return

    getPostReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const getPostReports = async () => {
    if (!post) return;

    try {
      const res = await apiServices.getPostReports(post.id);
      setReports(res.post_reports)
    } catch(error: any) {
      dispatch(setErrorObj(error));
    }
  }

  if (!post) {
    return (<></>);
  }
  return (
    <DisplayModal title={post.title} open={open} highlightWords={highlightWords} onClose={onClose} sx={styles.container}>
      <Typography sx={styles.title}>{T("mng_rejected_posts_report_reasons")}</Typography>
      <Box sx={styles.contents}>
        {reports?.map((report: any, index: number) => (
          <Box sx={styles.data.container} key={index}>
            <Avatar
              alt={report.nickname}
              sx={styles.data.avatar}
              src={report.image ? convertUserImage(report.image) : profile}
            />
            <Box sx={styles.data.contents}>
              <Box sx={styles.data.contents.header}>
                <Typography variant="body2">
                  {report.nickname}
                </Typography>
                <Typography variant="body2">
                  {dayjs(report.created_at).format("YYYY/MM/DD HH:mm")}
                </Typography>
              </Box>

              <Typography>{report.reason}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </DisplayModal>
  );
}

const styles = {
  container: {
    width: "max-content",
    minWidth: "50%",
    maxWidth: "85%",
    maxHeight: "90%"
  },

  title: {
    marginY: 1,
    fontSize: 18,
    lineHeight: "1rem",
    fontWeight: 400,
    textAlign: "center"
  },

  contents: {
    overflowY: "auto"
  },

  data: {
    container: {
      display: "flex",
      width: "100%",
      padding: 2
    },
    avatar: {
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      marginRight: 1,
    },
    contents: {
      flex: "auto",
      header: {
        flex: "auto",
        display: "flex",
        justifyContent: "space-between",
        color: colors.farm_black,
        fontSize: 12,
        "& .MuiTypography-root": {
          fontSize: "inherit"
        }
      },
    }
  }
}